import { injectable, inject } from 'inversify';
import Client from '@dealroadshow/socket-frontend-sdk';
import type { ISocketDispatcher } from './DI/interfaces';
import DITypes from './DI/types';

@injectable()
export default class SocketClient extends Client {
  constructor(
    @inject(DITypes.SocketDispatcher) dispatcher: ISocketDispatcher,
  ) {
    super(dispatcher);
  }
}
